module.exports = __webpack_public_path__ + "static/media/icon_09.7dfc77e7.png";